<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Relearn 2021</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Summer school, workshop, anarchive, web-to-print, chatbot</p>
        <p>Relearn is a summerschool which welcomes persons, artists, students, teachers from all backgrounds and disciplines. Participants gather to learn from and teach to each other, beyond the traditional paradigms of education. Relearn researches convivial, experimental and deviant methods and means in the fields of design, computing and education, challenging the normal roles and separations in them (teacher/student, developer/user, art/life…). In 2021, Relearn was organized together with Luke Murphy and Santiago Piñol at Varia, De Bollenpandje and Ook Huis.</p>
        <p>During the summer school, the activities were documented in real time using a self-hosted XMPP chat and a chatbot into an anarchive. The full documentation can be found on the <a href="http://relearn.be/2021/">website</a>.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/relearn.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/relearn/people.gif"></b-img>


      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/relearn/publication.jpg"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/relearn/outside.jpg"></b-img>

      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'RelearnPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
